const characters = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];
export default function idGen(digit = 6) {
  let id = "";
  for (let i = 0; i < digit; i++) {
    const random = Math.floor(Math.random() * 36);
    id = id + characters[random];
  }
  return id;
}

// console.log(idGen(15));
